import axios from 'axios'
import APIConfig from '@/data/remote/APIConfig.js'

export default class ProjectDepartmentBudgetService {
    constructor() {
        this.apis = {
            getAll: () => axios.get(APIConfig.APIURL + '/projectDepartmentBudget'),
            add: (payload) => axios.post(APIConfig.APIURL + '/projectDepartmentBudget', payload),
            edit: (id, payload) => axios.put(APIConfig.APIURL + `/projectDepartmentBudget/${id}`, payload),
            // inActivate: (id) => axios.post(APIConfig.APIURL + `/projectDepartmentBudget/${id}/inactivate`),
            delete: (id) => axios.delete(APIConfig.APIURL + `/projectDepartmentBudget/${id}`),
            comment: (id, payload) => axios.put(APIConfig.APIURL + `/projectDepartmentBudget/${id}/comment`, payload),
        }
    }

    prepareData(vm) {
        return new Promise((resolve, reject) => {
            if (vm.$store.state.projectDepartmentBudget.isFetched) {
                resolve(vm.$store.state.projectDepartmentBudget.list)
                return
            }
            if (vm.$store.state.projectDepartmentBudget.isFetching) {
                var timer = setInterval(() => {
                    if (vm.$store.state.projectDepartmentBudget.isFetching) return
                    clearInterval(timer)
                    if (vm.$store.state.projectDepartmentBudget.isFetched) {
                        resolve(vm.$store.state.projectDepartmentBudget.list)
                    } else {
                        reject('無法取得資料，請嘗試重新整理')
                    }
                }, 500)
                return
            }
            return this.getAll(vm)
                .then(res => {
                    vm.$store.state.projectDepartmentBudget.isFetched = true
                    vm.$store.state.projectDepartmentBudget.isReloaded = false
                    vm.$store.state.projectDepartmentBudget.list = res.data.result || []
                    return res
                })
                .then(res => {
                    vm.$store.state.projectDepartmentBudget.isFetching = false
                    resolve()
                    return res
                })
                .catch(err => {
                    vm.$store.state.projectDepartmentBudget.isFetching = false
                    reject(err)
                })
        })
    }

    getAll(vm) {
        return new Promise((resolve, reject) => {
            this.apis.getAll()
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    add(vm, payload) {
        return new Promise((resolve, reject) => {
            this.apis.add(payload)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    edit(vm, payload) {
        return new Promise((resolve, reject) => {
            this.apis.edit(payload.ID, payload)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    inActivate(vm, id) {
        return new Promise((resolve, reject) => {
            this.apis.inActivate(id)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    delete(vm, id) {
        return new Promise((resolve, reject) => {
            this.apis.delete(id)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    comment(vm, payload) {
        return new Promise((resolve, reject) => {
            this.apis.comment(payload.ID, payload)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }
}
